import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-user-groups.tsx
/**
* icon.24.user.groups
*
* People, team
*
* Keywords: group, community, users, team, multiple, collaboration, social, organization
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTkuNSAxMWEzLjUgMy41IDAgMCAxIDMuNSAzLjV2M2EuNS41IDAgMCAxLTEgMHYtM2EyLjUgMi41IDAgMCAwLTUgMHYzYS41LjUgMCAwIDEtMSAwdi0zQTMuNSAzLjUgMCAwIDEgOS41IDExbTUuNSAxYTMgMyAwIDAgMSAzIDN2Mi41YS41LjUgMCAwIDEtMSAwVjE1YTIgMiAwIDAgMC0yLjQtMS45Ni41LjUgMCAwIDEtLjItLjk4cS4yOTItLjA2LjYtLjA2bTAtNWEyIDIgMCAxIDEgMCA0IDIgMiAwIDAgMSAwLTRNOS41IDVhMi41IDIuNSAwIDEgMSAwIDUgMi41IDIuNSAwIDAgMSAwLTVNMTUgOGExIDEgMCAxIDAgMCAyIDEgMSAwIDAgMCAwLTJNOS41IDZhMS41IDEuNSAwIDEgMCAwIDMgMS41IDEuNSAwIDAgMCAwLTMiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-9609
*/
const Icon24UserGroups = memo(function Icon24UserGroups(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M9.5 11a3.5 3.5 0 0 1 3.5 3.5v3a.5.5 0 0 1-1 0v-3a2.5 2.5 0 0 0-5 0v3a.5.5 0 0 1-1 0v-3A3.5 3.5 0 0 1 9.5 11m5.5 1a3 3 0 0 1 3 3v2.5a.5.5 0 0 1-1 0V15a2 2 0 0 0-2.4-1.96.5.5 0 0 1-.2-.98q.292-.06.6-.06m0-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4M9.5 5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M15 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2M9.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
		})
	});
});
//#endregion
export { Icon24UserGroups };

//# sourceMappingURL=icon-24-user-groups.js.map